import { render } from "./Button.vue?vue&type=template&id=7eafc808"
const script = {}

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Elements/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7eafc808"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7eafc808', __exports__)) {
    api.reload('7eafc808', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=7eafc808", () => {
    api.rerender('7eafc808', render)
  })

}


export default __exports__